export default "__VITE_ASSET__f4066169__"